/* eslint-disable import/prefer-default-export */

import { Header } from '../../../../pricing-simulator/types/generic-table.model';
import { IDataRow } from '../../../../pricing-simulator/types/simulation-view-table.model';

export const getCurrentRowToChangeFromState = (depth: number, rowData: any, currentRowIndex: number) => {
    let rowToChange: IDataRow = {};
    if (depth === 0) {
        return rowData;
    }
    const makeUpdatedDataLevel = (metaData): any[] => metaData.map((rowElement: any) => {
        if (rowElement.parent.data.index === currentRowIndex) {
            rowToChange = rowElement;
        } else if (rowElement.children && rowElement.children.length) {
            return makeUpdatedDataLevel(rowElement.children);
        }
    });
    makeUpdatedDataLevel(rowData.children);
    return rowToChange;
};

export function updateChildrenInputValue(childrenRow: any[], newInputValue: string | number, fieldToUpdate: string) {
    childrenRow.forEach(child => {
        if (child.children) {
            updateChildrenInputValue(child.children, newInputValue, fieldToUpdate);
        }
        // eslint-disable-next-line no-param-reassign
        child.parent.data[fieldToUpdate] = newInputValue;
    });
}

/* 
    Updating the child rows of the row from where the input value has been changed
    & also return the row & its parent
*/
export function getParentRows(
    parentRow: any,
    columnMetadata: Header,
    newInputValue: number | string,
    rowIndices: number[]
) {
    const indices = rowIndices.slice();
    const parentRows = [parentRow];
    let currentRow = parentRow;
    while (indices.length) {
        const index = indices.pop();
        currentRow = currentRow.children[index];
        parentRows.unshift(currentRow);
    }
    const { children } = currentRow;
    if (Array.isArray(children) && children.length) {
        updateChildrenInputValue(children, newInputValue, columnMetadata.parent.parent_field);
    }
    return parentRows;
}

export function round2(val: unknown): number {
  const n = typeof val === 'number' ? val : parseFloat(String(val));
  return Number.isFinite(n) ? Number(n.toFixed(2)) : 0;
}



